
const person =[
    {
        "_id": "622a185fcdebfb2402d58c38",
        "name": "Random Person",
        "location": "Austin, Texas",
        "description": "blah blah blah...",
        "website": "https://www.cheservices.com/telehealth/anxiety-therapy?utm_source=google&utm_medium=cpc&utm_campaign=CHE_Telehealth&utm_keyword=panic%20attack&utm_content=GA&gclid=CjwKCAiA4KaRBhBdEiwAZi1zzo1Uj1TtwsZBtTRSbIiVDAq8ccyMB9xoiPknNzhlpyyK8egnTWWWoBoCkG8QAvD_BwE",
        "__v": 0
    }
]


export default person;